<template>
  <div>
    <v-row>
      <v-col cols="12" md="10">
        <span class="titulo-header">Crear Solicitud</span>
      </v-col>
      <v-col cols="12" md="2" style="text-align: end;">
        <v-btn
          rounded
          dark
          outlined
          color="#00a7e4"
          @click="toDashboard"
          style="margin-right: 11px;"
        >
          Cancelar
        </v-btn>
      </v-col>
    </v-row>
    <div class="pt-5">
      <commond-form
        :request="request"
        :route="'/v1/solicitud/insert/inbound'"
        :run="run"
        :action="'POST'"
        @cancel="run = false"
        @success="changeComponent"
      >
        <template v-slot:data>
          <CreateSolicitudDataForm
            :currentStep="currentStep"
            @ChangeOnlyStep="ChangeOnlyStep"
          />
          <CreateSolicitudClienteForm
            :currentStep="currentStep"
            @ChangeOnlyStep="ChangeOnlyStep"
          />
          <SeguimientoSolicitudForm
            :currentStep="currentStep"
            :ramo="firstStepData.categoriaSelected"
            @ChangeOnlyStep="ChangeOnlyStep"
            @goToSave="goToSave"
          />
        </template>
      </commond-form>
      <CommonSolicitudCreadaModal
        :dialog="successSolicitud"
        @userChoice="changeView"
      />
    </div>
  </div>
</template>

<script>
import CommondForm from "@/components/commonComponents/CommondForm.vue";
import CreateSolicitudDataForm from "./CreateSolicitudData/CreateSolicitudDataForm.vue";
import CreateSolicitudClienteForm from "./CreateSolicitudData/CreateSolicitudClienteForm.vue";
import SeguimientoSolicitudForm from "./CreateSolicitudData/SeguimientoSolicitudForm.vue";
import CommonSolicitudCreadaModal from "@/components/commonComponents/CommonSolicitudCreadaModal.vue";
import { getProductoList } from "../../../../../services/productos/product.service";
import { createClientePost } from "@/services/cliente/Clientes.js";
import moment from "moment";

export default {
  components: {
    CreateSolicitudDataForm,
    CommondForm,
    CreateSolicitudClienteForm,
    SeguimientoSolicitudForm,
    CommonSolicitudCreadaModal,
  },
  data() {
    return {
      request: {},
      firstStepData: {
        ramo: null,
        tipoSelected: null,
      },
      secondStepData: {},
      thirdStepData: {},
      currentStep: 1,
      run: false,
      successSolicitud: false,
      solicitudCreada: {},
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
    };
  },
  methods: {
    ChangeOnlyStep(toStep, polizaData) {
      this.currentStep = toStep;
      if (polizaData != null)
        switch (toStep) {
          case 2:
            this.firstStepData = polizaData;
            break;
          case 3:
            this.secondStepData = polizaData;
            break;
          case 4:
            this.thirdStepData = polizaData;
            break;
        }
    },
    toDashboard() {
      this.$router.push("main-hub/2");
    },
    async goToSave(data) {
      if (!this.isAgente)
        this.request = {
          ...this.firstStepData,
          ...this.secondStepData,
          ...this.thirdStepData,
          ...data,
        };
      else
        this.request = {
          ...this.firstStepData,
          ...this.secondStepData,
          ...data,
          ...{
            operadorUuid: null,
            procesoCotizacionSelected: "Cotización",
            solicitudCompletaSelected: false,
            checkPendienteInfo: false,
            checkCancelacion: false,
            causaPendienteInformacion: null,
          },
        };
      this.request.agenteId = Number(localStorage.getItem("id"));
      this.request.productoId = this.firstStepData.producto_id;
      this.request.areaNegocioId = 6;
      console.log(this.request);

      if (
        this.request.clienteId === undefined ||
        this.request.clienteId === null
      ) {
        this.$toast.info(
          "Detectamos que el cliente no estaba registrado vamos a crear un registro de cliente."
        );
        let response = await this.createClient();
        this.request.clienteId = response.id;
      }
      this.run = true;
    },
    async changeComponent(response) {
      this.solicitudCreada = response.data;
      if (this.isAgente) this.successSolicitud = true;
      else {
        if (await this.checkIfNeedBeneficiary()) {
          this.$router.push({
            name: "detalles-solicitud",
            params: {
              id: this.solicitudCreada.id,
            },
            query: {
              beneficiarios: "true",
            },
          });
        } else
          this.$router.push("/detalles-solicitud/" + this.solicitudCreada.id);
      }
    },
    async changeView(val) {
      if (val) {
        if (await this.checkIfNeedBeneficiary()) {
          this.$router.push({
            name: "detalles-solicitud",
            params: {
              id: this.solicitudCreada.id,
            },
            query: {
              beneficiarios: "true",
            },
          });
        } else
          this.$router.push("/detalles-solicitud/" + this.solicitudCreada.id);
      } else location.reload();
    },
    async checkIfNeedBeneficiary() {
      const products = await getProductoList();
      const currentProduct = products.find(
        (e) => e.id == this.solicitudCreada.producto_id
      );
      return currentProduct ? currentProduct.beneficiario : false;
    },
    async createClient() {
      try {
        let request = {
          status: 0,
          regimen: this.request.regimen_persona ?? null,
          nombres: this.request.nombres ?? null,
          apellidoPaterno: this.request.apellidoPaterno ?? null,
          apellidoMaterno: this.request.apellidoMaterno ?? null,
          genero: this.request.genero ?? null,
          fechaNacimiento: this.request.fechaNacimiento ?? null,
          estadoCivil: this.request.estadoCivilSelected ?? null,
          nombreEmpresa: null,
          razonSocial: null,
          fechaConstitucion: moment().format("YYYY-MM-DD"),
          rfc: this.request.rfc,
          correoElectronico: this.request.correoElectronico ?? null,
          celular: this.request.celular ?? null,
          telefonoOficina: this.request.celular ?? null,
          agenteId: this.request.agenteId ? this.request.agenteId : 700,
          direccionFacturacionId: "",
          fechaCreacion: null,
          creadoPor: localStorage.getItem("agenteUuid"),
          modificadoPor: localStorage.getItem("agenteUuid"),
          origen: "Inbound",
        };
        let response = await createClientePost(request);
        this.$toast.success("Cliente creado con exito");
        return response;
      } catch (e) {
        this.$toast.error("Fallo la creacion del cliente");
      }
    },
  },
  computed: {
    isAgente() {
      return this.rol == "AGENT";
    },
  },
};
</script>
